(function() {
    'use strict';
    /*
     * Copyright (c) 2015-2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('ihhViewEditPerson', ihhViewEditPerson);

    /**
     * A directive for displaying a person in read mode and supporting an edit mode. Intended for use with
     * controllers that derive from {@link ihh-common-web.ViewEditCtrlBase}.
     * @ngdoc directive
     * @name ihh-view-edit-person
     * @memberOf ihh-common-web
     * @example
     * <ihh-view-edit-person
     *    person-category="Dog Catcher"
     *    edit-flag="isEdit"
     *    person="dogCatcher.person"
     *    person-edit="dogCatcherTemp.person"
     *    get-active="isDogCatcherActiveFn"
     *    set-active="setDogCatcherActiveFn"
     *    get-thumbnail-url="someGetThumbnailFn"
     *    thumbnailContainer="dogCatcherTemp"
     *    get-thumbnailResource="resourceGetFn"
     *    set-dirty="someSetDirtyFn">
     * </ihh-view-edit-text>
     */
    function ihhViewEditPerson() {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                /**
                 * A string specifying a category of person being edited. Used for display.
                 * @ngdoc property
                 * @name person-category
                 * @memberOf ihh-common-web.ihh-view-edit-person
                 */
                personCategory: '@',

                /**
                 * The scope variable used to track view and edit mode.
                 * @ngdoc property
                 * @name edit-flag
                 * @memberOf ihh-common-web.ihh-view-edit-person
                 */
                editFlag: '=',

                /**
                 * The scope variable used as the model for displaying the person in view mode. Must be a person object.
                 * @ngdoc property
                 * @name person
                 * @memberOf ihh-common-web.ihh-view-edit-person
                 */
                person: '=',

                /**
                 * The scope variable used as the model for the person when in edit mode.
                 * @ngdoc property
                 * @name person-edit
                 * @memberOf ihh-common-web.ihh-view-edit-person
                 */
                personEdit: '=',

                /**
                 * A function that gets the active flag for the edited object in context.
                 * @ngdoc property
                 * @name get-active
                 * @memberOf ihh-common-web.ihh-view-edit-person
                 */
                getActive: '=',

                /**
                 * A function that sets the active flag for the edited person in context.
                 * @ngdoc property
                 * @name set-active
                 * @memberOf ihh-common-web.ihh-view-edit-person
                 */
                setActive: '=',

                /**
                 * The scope variable used to track role type.
                 * @ngdoc property
                 * @name role-type
                 * @memberOf ihh-common-web.ihh-view-edit-person
                 */
                roleType: '=',

                /**
                 * A function that gets the thumbnail url edited person in context.
                 * @ngdoc property
                 * @name get-thumbnail-url
                 * @memberOf ihh-common-web.ihh-view-edit-person
                 */
                getThumbnailUrl: '=',

                /**
                 * The object that contains the 'thumbnail' property.
                 * @ngdoc property
                 * @name thumbnail-container
                 * @memberOf ihh-common-web.ihh-view-edit-person
                 */
                thumbnailContainer: '=',

                /**
                 * A function that returns a resource for uploading a thumbnail.
                 * @ngdoc property
                 * @name get-thumbnail-resource
                 * @memberOf ihh-common-web.ihh-view-edit-person
                 */
                getThumbnailResource: '=',

                /**
                 * A function that marks the record dirty.
                 * @ngdoc property
                 * @name set-dirty
                 * @memberOf ihh-common-web.ihh-view-edit-person
                 */
                setDirty: '='
            },
            controller: 'ihh.common-web.ViewEditPersonCtrl',
            templateUrl: 'view-edit/view-edit-person.tpl.html'
        };
    }
})();